__turbopack_context__.v({
  "closeBtn": "Primodal-module__AolcWW__closeBtn",
  "commonBtnGetapp": "Primodal-module__AolcWW__commonBtnGetapp",
  "getApp": "Primodal-module__AolcWW__getApp",
  "image": "Primodal-module__AolcWW__image",
  "modal": "Primodal-module__AolcWW__modal",
  "modalContent": "Primodal-module__AolcWW__modalContent",
  "modalContentleft": "Primodal-module__AolcWW__modalContentleft",
  "modalContentright": "Primodal-module__AolcWW__modalContentright",
  "overlay": "Primodal-module__AolcWW__overlay",
});
